@if (pageReady) {
  <main class="gs-page">
    <div class="refer-friend-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      @if (referAFriendCode === "") {
        <div class="gs-content-container">
          <h2 class="refer-friend-label">{{ pageLabels.referFriendTitleText }}</h2>
          <p class="refer-friend-subtitle">{{ pageLabels.referFriendSubTitleText }}</p>
          <mat-divider class="ref-friend-divider"></mat-divider>
          @if (!hasEmail) {
            <p>{{ pageLabels.referFriendProvideEmailText }}</p>
            <app-email-form [emailData]="emailFormData"></app-email-form>
          }
        </div>
        <div class="cta-container">
          <button
            role="link"
            mat-flat-button
            color="primary"
            class="gs-form-button-primary"
            (click)="getReferralCode()"
          >
            {{ pageLabels.referFriendGetReferralCodeText }}
          </button>
        </div>
      } @else {
        <div class="gs-content-container">
          <h2 class="refer-friend-label">{{ pageLabels.referFriendCreditTitleText }}</h2>
          <p class="ref-friend-center-text">
            {{ pageLabels.referFriendCreditSubTitleText }}
          </p>
          <mat-divider class="ref-friend-divider"></mat-divider>
          <p class="ref-friend-center-text">{{ pageLabels.referFriendCreditSocialMediaText }}</p>
          <mat-form-field class="refer-a-friend" appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              #referFriendCode
              type="text"
              formControlName="referFriendCode"
              value="{{ accountDetail.ReferFriendCode }}"
              id="referFriendCode"
              [disabled]="true"
            />
            <button
              class="copy-paste-btn bucket-btn"
              mat-icon-button
              matTooltip="Copy"
              matTooltipPosition="above"
              matSuffix
              aria-label="Copy Refer a Friend Code"
              (keydown.enter)="copyText(referFriendCode.value)"
              (keydown.space)="copyText(referFriendCode.value)"
              (click)="copyText(referFriendCode.value)"
            >
              <i class="fa-thin fa-copy"></i>
            </button>
          </mat-form-field>
          <a
            href="javascript:void(0);"
            class="fb-share-button"
            (click)="openFB()"
            aria-label="Share Refer A Friend Code to Facebook"
            ><i class="fa-brands fa-facebook"></i> Share</a
          >
        </div>
        <div class="cta-container">
          <a
            [attr.aria-label]="pageLabels.referFriendButton.value.data.ariaLabel"
            class="gs-link-btn bucket-btn"
            [routerLink]="pageLabels.referFriendButton.value.data.url"
            >{{ pageLabels.referFriendButton.value.data.linkText }}</a
          >
        </div>
      }
    </div>
  </main>
}
